module.exports = __webpack_public_path__ + "static/media/logo_juego_letra_M.46b7d744.bin";